import React from "react";
import loadable from "@loadable/component";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import usePostHook from "../../customHooks/usePostHook";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../../components/Reusable/Spinner";
import { useNavigate } from "react-router-dom";
const CreateReturnBranchComponent = loadable(
  () => import("../../components/ReturnBranch/CreateReturnBranch")
);
const CreateReturnBranch = () => {
  const navigate = useNavigate();
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["return-branch"],
  });
  const { data: profile, isLoading } = useGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });
  const handleCreate = async (values: any, setError: any) => {
    const url = `${APIS.RTV_BRANCH}`;
    let formData = {
      ...values,
      type: "rtv",
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res.status == 201) {
        console.log(res?.data);
        navigate(`/edit/${res?.data?.id}`);
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create RTV Branch
        </span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <CreateReturnBranchComponent
          isLoading={isPostLoading}
          handleCreate={handleCreate}
          defaultBranch={profile?.default_branch}
        />
      )}
    </>
  );
};

export default CreateReturnBranch;
